import { render } from "./SettingsPersonal.vue?vue&type=template&id=579cea96"
import script from "./SettingsPersonal.vue?vue&type=script&lang=js"
export * from "./SettingsPersonal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__